<script>
  import { adminAddLicensesAbandoned } from "../../../../api/admin.js";
  import CrmFeatureGuard from "../../../components/feature-flags/CrmFeatureGuard.svelte";
  import MarketingModal from "../MarketingModal.svelte";
  import { showProjectsAddLicensesModalStore } from "./stores.js";

  const handleSeeInAction = () => {
    window.location.href = "https://sourcewhale.com/projects";
  };

  const handleClose = async () => {
    if ($showProjectsAddLicensesModalStore) {
      $showProjectsAddLicensesModalStore = false;
      adminAddLicensesAbandoned({ additions: { projects: 1 } });
    }
  };
</script>

<CrmFeatureGuard>
  {#snippet fallback()}
    <MarketingModal
      title="Your SourceWhale platform,<br />now complete with a CRM & ATS."
      subtitle="Projects brings every module together in one fast, recruiter-first workspace"
      previewImageSrc="/assets/img/marketing/projects-preview.svg"
      previewImageAlt="Projects interface preview"
      secondaryButtonAction={handleSeeInAction}
      onclose={handleClose}
      license="projects"
      seenKey="dismissedProjectsMarketingModal"
      forceShow={$showProjectsAddLicensesModalStore}
    />
  {/snippet}
</CrmFeatureGuard>
